import { useEffect, useMemo, useState } from 'react';
import UniversalRecordTable from '../Tables/universalRecord/UniversalRecordTable';
import { useDocumentTemplate } from '../../hooks/documentTemplate/useDocumentTemplate';
import { documentTemplateColumns } from '../../features/documentTemplate/documentTemplateColumns';
import DocumentTemplateRegistrationPopup from './DocumentTemplateRegistrationPopup';
import DocumentTemplateEditPopup from './DocumentTemplateEditPopup';
import TemplateIframePreviewModal from './TemplateIframePreviewModal';

const DocumentTemplateTableSection: React.FC = () => {
  const {
    list,
    form,
    handlerGetAllTemplates,
    showRegistrationModal,
    openRegistrationModal,
    closeRegistrationModal,
    showEditModal,
    fetchTemplateById,
    saveTemplate,
    toggleStatus,
  } = useDocumentTemplate();

  const columns = useMemo(() => documentTemplateColumns, []);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState<number | null>(
    null
  );

  useEffect(() => {
    handlerGetAllTemplates(); // 🚀 Carga las plantillas al montar el componente
  }, []);

  const getActions = (row: any) => [
    {
      key: 'view',
      label: 'Ver Plantilla',
      onClick: () => {
        setSelectedTemplateId(row.id);
        setPreviewOpen(true);
      },
    },
    {
      key: 'edit',
      label: 'Editar',
      onClick: () => {
        fetchTemplateById(row.id, 'edit'); // ✅ Carga el formulario y abre modal
      },
    },
    {
      key: 'deactivate',
      label: 'Activar/Desactivar',
      onClick: () => toggleStatus(row.id),
    },
  ];

  return (
    <>
      <UniversalRecordTable
        columns={columns}
        data={list}
        getActions={getActions}
        showPagination={false}
        enableRowClick={true}
        onPageChange={() => {}}
        onPageSizeChange={() => {}}
        noDataMessage="Aún no hay plantillas registradas. Usa el botón para agregar una nueva."
        topRightAction={{
          label: 'Nueva Plantilla',
          onClick: openRegistrationModal,
        }}
      />

      {/* Registro de nueva plantilla */}
      <DocumentTemplateRegistrationPopup
        isOpen={showRegistrationModal}
        onClose={closeRegistrationModal}
        onSave={(file) => saveTemplate(form, file)}
      />

      {/* Edición de plantilla existente */}
      <DocumentTemplateEditPopup
        isOpen={showEditModal}
        onUpdate={(file) => saveTemplate(form, file)}
      />

      {/* Vista previa HTML */}
      <TemplateIframePreviewModal
        id={selectedTemplateId}
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
      />
    </>
  );
};

export default DocumentTemplateTableSection;
